import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'

import {
  Flex,
  FlexItem,
  MESSAGE_BOX_VARIANT_WARNING,
  MessageBox
} from 'mailup-web-components'
import ModalFilterDetails from '../ModalFilterDetails/ModalFilterDetails'
import Footer from './Footer'
import PanelActivate from './PanelActivate'
import PanelGeneralInfo from './PanelGeneralInfo'
import PanelSending from './PanelSending'
import Thumbnail from './Thumbnail'

import {
  fetchStep4DataCallback,
  fetchStep4ThumbnailCallback
} from 'Pages/Campaign/recoil/callbacks/callbacks'
import { messageIsOnSentState } from 'Pages/Campaign/recoil/state/page'

const Step4 = () => {
  const intl = useIntl()
  const fetchData = useRecoilCallback(fetchStep4DataCallback, [])
  const fetchThumb = useRecoilCallback(fetchStep4ThumbnailCallback, [])
  const [{ isOnSent, showMessageBox }, setShow] =
    useRecoilState(messageIsOnSentState)

  useEffect(() => {
    fetchData()
    fetchThumb()
  }, [])

  const handleClose = () => {
    setShow((prev) => ({ ...prev, showMessageBox: false }))
  }

  return (
    <>
      <ModalFilterDetails />
      {isOnSent && showMessageBox && (
        <>
          <MessageBox
            variant={MESSAGE_BOX_VARIANT_WARNING}
            title={intl.formatMessage({
              id: 'Load.EmailMessageList.MessageIsOnSentWarning'
            })}
            closeButton
            closeButtonCallback={handleClose}
          />
        </>
      )}
      <Flex
        columnGap='32px'
        margin={isOnSent && showMessageBox ? '24px 0 0 0' : '0'}
      >
        <FlexItem width='25%'>
          <Thumbnail />
        </FlexItem>
        <FlexItem width='75%'>
          <PanelActivate />
          <PanelGeneralInfo />
          <PanelSending />
        </FlexItem>
      </Flex>
      <Footer />
    </>
  )
}

export default Step4
